import _ from "lodash";
import PropTypes from "prop-types";
import React from "react";
import OverlayTrigger from "react-bootstrap/OverlayTrigger";
import BootstrapTable from "react-bootstrap/Table";
import Tooltip from "react-bootstrap/Tooltip";
import { FormattedMessage, useIntl } from "react-intl";
import * as uuid from "uuid";
import { formatNumber } from "./NumberFormatUtils";

const TextTable = ({ data, subQuestionDetails, firstColumnTitle, years, tableId }) => {
  const intl = useIntl();

  const isTable = !!data.tableIdentifier;
  const newArray = _.groupBy(subQuestionDetails, "zaxisValue");
  let footerEmptyCols = [];
  for (let i = 0; i < years.length * 2 - 1; i++) {
    footerEmptyCols.push(<td key={uuid.v4()}></td>);
  }

  const generateTooltip = (text) => {
    return <Tooltip id="infoTooltip">{text}</Tooltip>;
  };

  return (
    <BootstrapTable responsive striped bordered hover className="horizontal" id={tableId}>
      <thead>
        <tr>
          <th>{firstColumnTitle && firstColumnTitle}</th>
          <th>
            <FormattedMessage id="survey.editor.toolbox.projectData.reportingYear" />
          </th>
          {isTable && (
            <th>
              <FormattedMessage id="user.surveyView.type.row" />
            </th>
          )}
          <th>
            <FormattedMessage id="user.surveyView.type.text" />
          </th>
        </tr>
      </thead>
      <tbody>
        {newArray
          ? Object.keys(newArray).map((key) => {
              let result = [];
              let rows = newArray[key];

              rows.forEach((row) => {
                isTable
                  ? result.push(
                      <tr key={uuid.v4()}>
                        <td key={uuid.v4()} title={row.zaxisInfo}>
                          {row.zaxisInfo || key}
                        </td>
                        <td key={uuid.v4()} title={row.xaxisValue}>
                          {row.xaxisValue}
                        </td>
                        <td key={uuid.v4()} title={row.yaxisValue}>
                          {formatNumber(row.yaxisValue)}
                        </td>
                        <td key={uuid.v4()} className={row.yaxisInfo ? "description" : ""}>
                          <OverlayTrigger placement="bottom" overlay={generateTooltip(row.yaxisInfo)}>
                            <div className={"ellipsisTableCol"}>{row.yaxisInfo ? row.yaxisInfo : "-"}</div>
                          </OverlayTrigger>
                        </td>
                      </tr>
                    )
                  : result.push(
                      <tr key={uuid.v4()}>
                        <td key={uuid.v4()} title={row.zaxisInfo}>
                          {row.zaxisInfo || key}
                        </td>
                        <td key={uuid.v4()} title={row.xaxisValue}>
                          {row.xaxisValue}
                        </td>
                        <td key={uuid.v4()} className={row.yaxisInfo ? "description" : ""}>
                          <OverlayTrigger placement="bottom" overlay={generateTooltip(row.yaxisInfo)}>
                            <div className={"ellipsisTableCol"}>{row.yaxisInfo ? row.yaxisInfo : "-"}</div>
                          </OverlayTrigger>
                        </td>
                      </tr>
                    );
              });
              return result;
            })
          : null}

        <tr className="bg-light">
          <th>{intl.formatMessage({ id: "collapsible.table.question.total" })}</th>
          {data?.data.map((d) => {
            return d.yaxisValue ? <th key={uuid.v4()}>{formatNumber(d.yaxisValue)}</th> : <th key={uuid.v4()}>{"-"}</th>;
          })}
          {footerEmptyCols}
        </tr>
      </tbody>
    </BootstrapTable>
  );
};

TextTable.propTypes = {
  subQuestionDetails: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
  data: PropTypes.object
};

export default TextTable;
